import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    paddingTop: '80px',
    paddingBottom: '100px',
    paddingLeft: '25px',
    paddingRight: '15px'
  },
  svg: {
    width: '250px', // Adjust width as needed
    height: 'auto', // Keeps aspect ratio
  },
});

const LogoFull = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <svg id="logosandtypes_com" className={classes.svg} viewBox="-60 -100 500 300">
        <g id="Queen_Mary_University" transform="translate(0 -.2)">
          <path
            id="path314"
            d="M75.8 113.5c-14.5 0-26.2-14.5-26.2-32.3 0-17.8 11.7-32.3 26.2-32.3S102 63.4 102 81.2c0 17.8-11.8 32.3-26.2 32.3m-.3-67.1C56 46.4 40.2 62 40.2 81.3c0 19.3 15.8 34.9 35.3 34.9 19.5 0 35.3-15.6 35.3-34.9 0-19.2-15.8-34.9-35.3-34.9"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path318"
            d="M75.8 113.5c-14.5 0-26.2-14.5-26.2-32.3 0-17.8 11.7-32.3 26.2-32.3S102 63.4 102 81.2c0 17.8-11.8 32.3-26.2 32.3Zm-.3-67.1C56 46.4 40.2 62 40.2 81.3c0 19.3 15.8 34.9 35.3 34.9 19.5 0 35.3-15.6 35.3-34.9 0-19.2-15.8-34.9-35.3-34.9Z"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path322"
            d="M1.8 48.9s25.6 18.1 13.9 40c0 0 17.2-23.5 23 9.6 0 0-4.9-7.5-14.5-5.6-8.3 1.6-9.4 8.1-9.4 8.1l-13-52.1"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path326"
            d="M1.8 48.9s25.6 18.1 13.9 40c0 0 17.2-23.5 23 9.6 0 0-4.9-7.5-14.5-5.6-8.3 1.6-9.4 8.1-9.4 8.1z"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path330"
            d="M148.2 48.9s-25.6 18.1-13.9 40c0 0-17.2-23.5-23 9.6 0 0 4.9-7.5 14.5-5.6 8.3 1.6 9.4 8.1 9.4 8.1l13-52.1"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path334"
            d="M148.2 48.9s-25.6 18.1-13.9 40c0 0-17.2-23.5-23 9.6 0 0 4.9-7.5 14.5-5.6 8.3 1.6 9.4 8.1 9.4 8.1z"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path338"
            d="M42.5 118.1c3.7-1.3 7.3-2.5 11.9-4.2-1.8-1-4.2-3-5.9-4.5-4.5 1.6-8.7 3.2-11.3 4.1-2.6.9-11.3 2.9-14.4-5.6-2.3-6.2 2.1-10.2 6.4-10.2 1.6 0 3.2.6 3.2.8-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c0-1.7-.9-3-2.2-4-1.8-1.2-4.2-1.9-6.5-1.9-5.2 0-9.7 4.6-10.5 9.9-.9 6 5.7 18.6 25.3 11.6"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path342"
            d="M42.5 118.1c3.7-1.3 7.3-2.5 11.9-4.2-1.8-1-4.2-3-5.9-4.5-4.5 1.6-8.7 3.2-11.3 4.1-2.6.9-11.3 2.9-14.4-5.6-2.3-6.2 2.1-10.2 6.4-10.2 1.6 0 3.2.6 3.2.8-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c0-1.7-.9-3-2.2-4-1.8-1.2-4.2-1.9-6.5-1.9-5.2 0-9.7 4.6-10.5 9.9-.9 6 5.7 18.6 25.3 11.6z"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path346"
            d="M22.1 128.2c-.8-2.8 2.2-5 6.7-5H123c4.5 0 7.5 2.3 6.7 5-.8 2.8-5.1 4.7-9.5 4.4l-36.3-2.7c-4.4-.3-11.7-.3-16.2 0l-36.1 2.7c-4.4.3-8.7-1.6-9.5-4.4"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path350"
            d="M22.1 128.2c-.8-2.8 2.2-5 6.7-5H123c4.5 0 7.5 2.3 6.7 5-.8 2.8-5.1 4.7-9.5 4.4l-36.3-2.7c-4.4-.3-11.7-.3-16.2 0l-36.1 2.7c-4.4.3-8.7-1.6-9.5-4.4z"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path354"
            d="M81.2 43c-3.8-5.5-1.5-8.9 1-8.9 4.1 0 5.6 2.3 5.5 6 2.2-1.3 4.2-4.6 4.2-7.7 0-3.1-2.4-6-5.5-6.1-3.8 0-5.8 1.2-7.5 3.2l.9-1.8c.7-1.3 1.4-2.9 1.4-4.2 0-1.7-.8-3.5-1.9-5.5-1.1-1.9-2.6-4.8-3.6-7.3-1 2.5-2.5 5.4-3.5 7.3-1.1 2-1.9 3.9-1.9 5.5 0 1.4.8 2.9 1.5 4.2.3.6.6 1.2.9 1.9-1.8-2.1-3.7-3.3-7.6-3.3-3.1 0-5.6 2.9-5.5 6.1 0 3.1 2 6.5 4.2 7.7 0-3.7 1.5-6 5.5-6 2.6 0 4.8 3.1.8 8.9 4.4-1.1 6.9-.9 11.1 0"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path358"
            d="M81.2 43c-3.8-5.5-1.5-8.9 1-8.9 4.1 0 5.6 2.3 5.5 6 2.2-1.3 4.2-4.6 4.2-7.7 0-3.1-2.4-6-5.5-6.1-3.8 0-5.8 1.2-7.5 3.2l.9-1.8c.7-1.3 1.4-2.9 1.4-4.2 0-1.7-.8-3.5-1.9-5.5-1.1-1.9-2.6-4.8-3.6-7.3-1 2.5-2.5 5.4-3.5 7.3-1.1 2-1.9 3.9-1.9 5.5 0 1.4.8 2.9 1.5 4.2.3.6.6 1.2.9 1.9-1.8-2.1-3.7-3.3-7.6-3.3-3.1 0-5.6 2.9-5.5 6.1 0 3.1 2 6.5 4.2 7.7 0-3.7 1.5-6 5.5-6 2.6 0 4.8 3.1.8 8.9 4.4-1.1 6.9-.9 11.1 0z"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path362"
            d="M133 107c-.7-5.3-5.3-9.9-10.5-9.9-2.3 0-4.8.7-6.5 1.9-1.3 1-2.2 2.3-2.2 4 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4c0-.2 1.6-.8 3.2-.8 4.3 0 8.7 4 6.4 10.2-3.1 8.5-11.8 6.5-14.4 5.6-2.6-.9-14.4-5.4-18.9-7l-.2.2c-10.8-3.9-12.5-4.5-17.7-5.6-16.6-3.4-17.7 7.6-17.7 7.6 0 .4 1.4-4.9 12.4-3.7 4.5.5 7.2 1.7 17.5 6l-.1.1c4.6 1.8 15.7 5.8 19.5 7.1 19.4 6.9 26-5.7 25.2-11.7"
            className="st1"
            fill="#FFFFFF"
          />
          <path
            id="path366"
            d="M133 107c-.7-5.3-5.3-9.9-10.5-9.9-2.3 0-4.8.7-6.5 1.9-1.3 1-2.2 2.3-2.2 4 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4c0-.2 1.6-.8 3.2-.8 4.3 0 8.7 4 6.4 10.2-3.1 8.5-11.8 6.5-14.4 5.6-2.6-.9-14.4-5.4-18.9-7l-.2.2c-10.8-3.9-12.5-4.5-17.7-5.6-16.6-3.4-17.7 7.6-17.7 7.6 0 .4 1.4-4.9 12.4-3.7 4.5.5 7.2 1.7 17.5 6l-.1.1c4.6 1.8 15.7 5.8 19.5 7.1 19.4 6.9 26-5.7 25.2-11.7z"
            className="st1"
            fill="#FFFFFF"
          />
        </g>
      </svg>
    </div>
  );
};

export default LogoFull;
